import { render, staticRenderFns } from "./OtherDetailsForm.vue?vue&type=template&id=1f59a531&"
import script from "./OtherDetailsForm.vue?vue&type=script&lang=js&"
export * from "./OtherDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports